export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '吃瓜热度榜', href: '#ranking' },
  { label: '热门爆料', href: '#cards' },
  { label: '联系我们', href: '#contact' },
  { label: '话题标签', href: '#topics' },
];

export const siteInfo = {
  name: '吃瓜网51',
  tag: '实时更新 · 独家爆料',
  heading: '吃瓜网51 — 最新最全的吃瓜爆料平台',
  slogan: '第一时间掌握娱乐圈最新动态',
  description:
    '吃瓜网51官网版是全网最受欢迎的娱乐八卦聚合平台，为您提供安全稳定的网页版与正式版访问入口。本站每日追踪娱乐圈最新动态，汇集明星八卦、影视爆料、综艺内幕、网红热点等全方位吃瓜资源，确保您不错过任何一个精彩瞬间。无论您是通过电脑还是手机访问，吃瓜网51官方首页都能让您轻松获取最新最热的爆料内容。',
  stats: [
    { label: '每日更新爆料', value: '200+' },
    { label: '覆盖热门话题', value: '50+' },
    { label: '全天候追踪', value: '7×24h' },
  ],
  primaryCta: { label: '立即吃瓜', href: '#updates' },
  secondaryCta: { label: '查看热门榜', href: '#ranking' },
};

export const updates = [
  {
    time: '10分钟前',
    tag: '独家',
    title: '某顶流男星被拍到深夜密会神秘女子，工作室紧急回应',
    summary: '据知情人士透露，该男星近日行程与公开信息存在多处矛盾，粉丝纷纷要求工作室给出合理解释。事件持续发酵中。',
  },
  {
    time: '28分钟前',
    tag: '热爆',
    title: '热门综艺录制现场突发状况，三位嘉宾当场翻脸离席',
    summary: '目击者称冲突起因是节目组临时修改规则，导致嘉宾之间产生严重分歧。节目组尚未对此事发表正式声明。',
  },
  {
    time: '1小时前',
    tag: '新料',
    title: '知名导演新片选角内幕曝光，角色争夺暗流涌动',
    summary: '多位一线演员的团队正在积极接洽，据悉片方已向三位实力派演员发出邀约，最终阵容预计下周公布。',
  },
  {
    time: '2小时前',
    tag: '追踪',
    title: '昔日荧幕情侣疑似复合，社交平台互动频繁引猜测',
    summary: '两人近期在同城出现，且社交账号互动明显增多。粉丝扒出多个同款物品，复合传闻再度甚嚣尘上。',
  },
  {
    time: '3小时前',
    tag: '爆料',
    title: '某品牌代言人即将更换，现任代言人合约到期不续',
    summary: '品牌方已开始接触多位新面孔，其中包括近期热度飙升的新晋演员和体育明星，最终人选仍悬而未决。',
  },
  {
    time: '5小时前',
    tag: '首发',
    title: '年度音乐盛典入围名单泄露，多位实力唱将意外落选',
    summary: '泄露名单显示今年评选规则有重大调整，部分往届常客未能入围引发热议，主办方称正式名单以官方发布为准。',
  },
  {
    time: '8小时前',
    tag: '快讯',
    title: '网络热议：某综艺选手背景遭质疑，节目组被指暗箱操作',
    summary: '网友发现该选手与节目组高层存在未公开的利益关系，大量观众在社交平台发起请愿要求节目组公开解释。',
  },
];

export const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%20conceptual%20image%20of%20paparazzi%20camera%20flashes%20against%20dark%20background%2C%20warm%20amber%20lighting%2C%20dramatic%20spotlight%20effect%2C%20representing%20celebrity%20news%20and%20entertainment%20industry%2C%20clean%20composition%20with%20bokeh%20light%20effects%2C%20magazine%20quality%20aesthetic&width=600&height=400&seq=card-01-2026&orientation=landscape',
    tag: '独家爆料',
    title: '顶流艺人合约纠纷升级，多方资本暗中角力',
    desc: '据可靠消息，该艺人经纪约即将到期，多家头部公司已抛出橄榄枝，涉及金额或创行业新高。业内人士分析此事将对整个娱乐圈格局产生深远影响。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20representation%20of%20social%20media%20trending%20topics%20with%20warm%20coral%20and%20gold%20gradient%20waves%2C%20dynamic%20flowing%20data%20visualization%20style%2C%20modern%20digital%20aesthetic%2C%20glowing%20particles%20suggesting%20viral%20content%20spread%2C%20sophisticated%20editorial%20design&width=600&height=400&seq=card-02-2026&orientation=landscape',
    tag: '热门追踪',
    title: '热门网剧第二季筹备启动，原班人马能否重聚成谜',
    desc: '第一季创下播放量纪录后，续集筹备备受瞩目。但多位主演档期紧张，制片方正全力协调。据悉新季将加入重磅新人，剧情全面升级。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Conceptual%20image%20of%20red%20carpet%20event%20atmosphere%20with%20warm%20golden%20lighting%20and%20soft%20focus%2C%20abstract%20crowd%20silhouettes%20with%20camera%20flashes%2C%20glamorous%20entertainment%20industry%20vibe%2C%20rich%20amber%20tones%2C%20cinematic%20editorial%20photography%20style&width=600&height=400&seq=card-03-2026&orientation=landscape',
    tag: '红毯直击',
    title: '年度颁奖礼红毯争艳，明星造型背后故事大揭秘',
    desc: '本届颁奖礼红毯环节看点十足，多位艺人以惊艳造型亮相。造型师透露部分礼服筹备超过三个月，奢侈品品牌竞争同样白热化。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20breaking%20news%20concept%20with%20torn%20paper%20texture%20and%20warm%20red-orange%20accents%2C%20layered%20typography-inspired%20geometric%20shapes%2C%20representing%20urgent%20entertainment%20updates%20and%20exclusive%20scoops%2C%20modern%20editorial%20design%20with%20dramatic%20contrast&width=600&height=400&seq=card-04-2026&orientation=landscape',
    tag: '深度揭秘',
    title: '演艺圈新老交替加速，95后艺人商业价值全面爆发',
    desc: '最新数据显示，年轻一代艺人代言数量和商业价值增速远超前辈。多个国际品牌已调整策略，将营销重心转向新生代偶像群体。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20composition%20of%20entertainment%20magazine%20cover%20aesthetic%20with%20warm%20tones%2C%20overlapping%20circles%20and%20organic%20shapes%20in%20coral%20and%20gold%2C%20soft%20gradient%20background%2C%20sophisticated%20lifestyle%20publication%20feel%2C%20clean%20modern%20design&width=600&height=400&seq=card-05-2026&orientation=landscape',
    tag: '综艺内幕',
    title: '现象级综艺幕后故事：制作团队首次公开创作历程',
    desc: '这档收视率屡创新高的节目背后有着不为人知的艰辛。总导演接受专访时透露了节目从创意到落地的全过程，以及面对争议时的坚持与调整。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Conceptual%20image%20of%20digital%20entertainment%20era%20with%20warm%20neon%20glow%20effects%20on%20dark%20surface%2C%20abstract%20data%20streams%20and%20notification%20bubbles%20in%20amber%20and%20coral%2C%20representing%20real-time%20celebrity%20news%20updates%2C%20futuristic%20editorial%20style&width=600&height=400&seq=card-06-2026&orientation=landscape',
    tag: '行业观察',
    title: '短视频冲击下传统娱乐媒体的转型与突围之路',
    desc: '面对短视频平台的强势崛起，传统娱乐媒体正在经历前所未有的变革。多位行业大咖分享了对未来趋势的判断，以及在新格局下的生存策略。',
  },
];

export const ranking = [
  { rank: 1, title: '某顶流男星深夜密会事件持续发酵', heat: '986万', trend: 'up' },
  { rank: 2, title: '热门综艺录制现场嘉宾冲突全记录', heat: '872万', trend: 'up' },
  { rank: 3, title: '知名导演新片选角大战正式打响', heat: '765万', trend: 'up' },
  { rank: 4, title: '昔日荧幕情侣复合传闻再添实锤', heat: '698万', trend: 'up' },
  { rank: 5, title: '年度音乐盛典入围名单引发巨大争议', heat: '623万', trend: 'up' },
  { rank: 6, title: '某品牌代言人更换在即引各方关注', heat: '541万', trend: 'down' },
  { rank: 7, title: '网络综艺选手背景调查持续深入', heat: '489万', trend: 'up' },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时全天候追踪娱乐圈动态，重大爆料第一时间推送，确保您永远快人一步获取最新吃瓜资源。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '吃瓜网51官网版采用多重安全防护，提供稳定可靠的网页版与正式版访问入口，让您安心畅享吃瓜乐趣。',
  },
  {
    icon: 'ri-global-line',
    title: '全平台覆盖',
    desc: '支持电脑、平板、手机等多终端访问，吃瓜网51网页版随时随地打开即用，无需下载安装，方便快捷。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '每日更新200+条独家爆料，覆盖明星八卦、影视内幕、综艺趣闻等全方位娱乐资讯，总有一条满足您的好奇心。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '真实互动',
    desc: '汇聚百万吃瓜群众，评论区真实热烈，每一条爆料都有深度讨论和多元观点碰撞，让吃瓜变成一种社交体验。',
  },
];

export const indexTopics = [
  { title: '明星恋情追踪', count: 128, icon: 'ri-heart-line' },
  { title: '影视剧爆料', count: 96, icon: 'ri-film-line' },
  { title: '综艺节目内幕', count: 87, icon: 'ri-tv-2-line' },
  { title: '网红热点事件', count: 74, icon: 'ri-live-line' },
  { title: '时尚品牌动态', count: 63, icon: 'ri-shirt-line' },
  { title: '音乐圈风云', count: 58, icon: 'ri-music-line' },
  { title: '体育娱乐跨界', count: 45, icon: 'ri-basketball-line' },
  { title: '国际娱乐资讯', count: 39, icon: 'ri-earth-line' },
];

export const about = {
  title: '关于吃瓜网51',
  content:
    '吃瓜网51成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的娱乐爆料内容。吃瓜网51官网版汇集了来自全网的优质吃瓜资源，通过专业编辑团队的筛选与整理，确保每一条资讯都具有可读性和话题性。我们的使命是让每一个热爱娱乐八卦的人，都能在吃瓜网51官方首页找到属于自己的快乐。作为行业标杆，吃瓜网51网页版持续优化用户体验，不断提升内容质量，已成为数千万用户每日必访的娱乐资讯入口。',
};

export const faqItems = [
  {
    q: '吃瓜网51的爆料内容是否可靠？',
    a: '吃瓜网51官网版的所有内容均来自公开渠道和可靠信息源，我们的编辑团队会对每条爆料进行多方核实。虽然娱乐八卦本身具有一定的不确定性，但我们始终坚持真实、客观的原则，对未经证实的信息会明确标注来源和可信度评级。',
  },
  {
    q: '如何访问吃瓜网51的官方首页？',
    a: '您可以直接在浏览器中输入吃瓜网51的官方网址访问我们的网页版。建议将本站加入浏览器收藏夹，以便随时获取最新爆料。同时请认准吃瓜网51官网版的官方标识，谨防仿冒网站。',
  },
  {
    q: '吃瓜网51网页版是否需要注册登录？',
    a: '目前吃瓜网51网页版浏览内容完全免费且无需注册。您可以自由浏览所有公开的爆料资讯、热门榜单和专题合集。未来我们可能推出会员专属功能，届时会提前公告通知。',
  },
  {
    q: '如何在手机上使用吃瓜网51？',
    a: '吃瓜网51正式版完美适配移动端浏览器，您只需在手机浏览器中打开我们的官方网址即可畅快使用。页面会自动适配手机屏幕尺寸，提供与桌面端同样流畅的浏览体验。我们也在积极推进移动端专属版本的开发。',
  },
];

export const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20ambient%20abstract%20composition%20with%20flowing%20organic%20shapes%20in%20coral%20and%20gold%20tones%2C%20representing%20trending%20hot%20topics%20in%20entertainment%2C%20soft%20dreamy%20gradient%20background%2C%20sophisticated%20editorial%20magazine%20spread%20aesthetic%2C%20luxurious%20feel&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
    tag: '专题',
    title: '2026上半年娱乐圈大事记盘点',
    desc: '从开年大瓜到暑期档热潮，回顾这半年来最令人难忘的娱乐事件与精彩瞬间。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20exclusive%20scoop%20concept%20with%20spotlight%20effect%20on%20golden%20geometric%20center%2C%20dark%20warm%20background%20with%20subtle%20texture%2C%20representing%20breaking%20celebrity%20news%20and%20insider%20information%2C%20high-end%20editorial%20photography%20style&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
    tag: '深度',
    title: '新生代演员崛起之路全解析',
    desc: '深度剖析95后演员如何在激烈竞争中脱颖而出，他们的成长故事与未来可期的发展方向。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20entertainment%20award%20season%20visualization%20with%20warm%20amber%20glow%20and%20crystal-like%20geometric%20shapes%2C%20sophisticated%20gold%20accents%2C%20red%20carpet%20ambiance%2C%20refined%20editorial%20design%20for%20featured%20content%20showcase&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
    tag: '盘点',
    title: '年度最具话题度综艺名场面',
    desc: '整理那些让全网热议的综艺名场面，从搞笑到感动，每一帧都值得反复回味。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20celebrity%20lifestyle%20concept%20with%20warm%20sunset%20tones%2C%20abstract%20silhouette%20shapes%20with%20golden%20rim%20lighting%2C%20luxurious%20and%20aspirational%20atmosphere%2C%20soft%20focus%20background%20bokeh%2C%20editorial%20magazine%20quality&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
    tag: '揭秘',
    title: '娱乐圈隐形富豪的生活方式',
    desc: '揭秘那些低调却资产惊人的娱乐圈隐形富豪，他们的投资版图和奢华生活令人咋舌。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20viral%20moment%20visualization%20with%20explosive%20warm%20coral%20particles%20radiating%20from%20center%2C%20dark%20amber%20background%2C%20representing%20trending%20content%20and%20social%20media%20buzz%2C%20energetic%20yet%20sophisticated%20editorial%20design&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
    tag: '趋势',
    title: 'AI虚拟偶像对娱乐圈的冲击与机遇',
    desc: '当AI技术进军娱乐产业，虚拟偶像正在改变行业生态。真实艺人与数字偶像的未来格局将如何演变？',
  },
];

export const contact = {
  title: '联系我们',
  intro: '欢迎各界人士通过以下方式与吃瓜网51取得联系。无论是爆料投稿、商务合作还是意见建议，我们都将认真对待每一条信息。',
  email: 'contact@chigua51.com',
  wechat: 'chigua51_official',
  weibo: '@吃瓜网51官方',
  tips: '爆料投稿请注明信息来源，我们将严格保护爆料人隐私。商务合作请简要说明合作意向，我们会在24小时内回复。',
};

export const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20coral%20gradient%20circle%2C%20simple%20geometric%20design%2C%20modern%20clean%20aesthetic%2C%20no%20text%20or%20letters&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    content: '这个站更新是真的快！刚才热搜上的事这里已经有详细整理了，比我刷微博还快一步。每天必来看一眼，已经成为习惯了哈哈。',
    likes: 328,
  },
  {
    name: '娱乐圈观察家',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20golden%20amber%20gradient%20circle%2C%20simple%20geometric%20design%2C%20modern%20clean%20aesthetic%2C%20no%20text%20or%20letters&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    content: '吃瓜网51的深度分析文章一直是我最喜欢的部分，不只是简单转述，还有很多行业内幕和独家解读，比那些只会复制粘贴的营销号强太多了。',
    likes: 256,
  },
  {
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20terracotta%20gradient%20circle%2C%20simple%20geometric%20design%2C%20modern%20clean%20aesthetic%2C%20no%20text%20or%20letters&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '8小时前',
    content: '大半夜睡不着刷到这个站，结果越看越精神！专题合集整理得太好了，一个专题就能把来龙去脉全部搞清楚，不用到处翻帖子，太省心了。',
    likes: 189,
  },
  {
    name: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20peach%20gradient%20circle%2C%20simple%20geometric%20design%2C%20modern%20clean%20aesthetic%2C%20no%20text%20or%20letters&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '12小时前',
    content: '对比了好几个吃瓜平台，还是这里的信息最全最靠谱。而且评论区氛围不错，大家理性讨论，不像其他地方全是粉丝控评和引战，这点很难得。',
    likes: 142,
  },
];

export const appInfo = {
  title: '随时随地，畅快吃瓜',
  subtitle: '吃瓜网51网页版完美适配手机浏览器，打开即用',
  features: [
    '无需下载安装，节省手机空间',
    '自动适配屏幕，流畅浏览体验',
    '极速加载，省流量更省心',
    '与桌面版内容完全同步',
  ],
};

export const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20video%20frame%20concept%20with%20cinematic%20aspect%20ratio%2C%20abstract%20entertainment%20news%20studio%20background%20with%20soft%20amber%20lighting%2C%20professional%20broadcast%20aesthetic%2C%20modern%20media%20production%20feel%2C%20clean%20composition&width=600&height=340&seq=media-01-2026&orientation=landscape',
    title: '本周娱乐圈十大热点回顾',
    duration: '08:24',
    views: '12.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Exclusive%20interview%20atmosphere%20with%20warm%20golden%20lighting%20and%20abstract%20microphone%20shapes%2C%20intimate%20conversational%20setting%20visualized%20through%20soft%20focus%20and%20bokeh%2C%20professional%20journalism%20aesthetic%2C%20warm%20amber%20and%20coral%20tones&width=600&height=340&seq=media-02-2026&orientation=landscape',
    title: '独家对话：业内人士深度解析选角内幕',
    duration: '15:36',
    views: '9.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20entertainment%20production%20concept%20with%20warm%20tungsten%20lighting%2C%20abstract%20camera%20equipment%20and%20film%20set%20elements%20in%20soft%20focus%2C%20cinematic%20color%20grading%20with%20golden%20tones%2C%20editorial%20documentary%20style&width=600&height=340&seq=media-03-2026&orientation=landscape',
    title: '幕后花絮：年度大剧拍摄现场直击',
    duration: '06:18',
    views: '7.2万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20review%20and%20analysis%20visualization%20with%20warm%20ambient%20lighting%2C%20abstract%20rating%20and%20commentary%20elements%20in%20coral%20and%20gold%2C%20sophisticated%20media%20critique%20aesthetic%2C%20modern%20digital%20publication%20feel&width=600&height=340&seq=media-04-2026&orientation=landscape',
    title: '吃瓜锐评：本月最具争议事件全梳理',
    duration: '11:42',
    views: '6.8万',
  },
];

export const topics = [
  { name: '顶流男星恋情', heat: '986万', tag: '爆' },
  { name: '综艺嘉宾冲突', heat: '872万', tag: '热' },
  { name: '导演选角内幕', heat: '765万', tag: '热' },
  { name: '荧幕情侣复合', heat: '698万', tag: '热' },
  { name: '音乐盛典争议', heat: '623万', tag: '新' },
  { name: '品牌代言更换', heat: '541万', tag: '新' },
  { name: '95后艺人崛起', heat: '456万', tag: '新' },
  { name: 'AI虚拟偶像', heat: '398万', tag: '新' },
  { name: '短视频冲击传统', heat: '312万', tag: '新' },
];

export const footerInfo = {
  description:
    '吃瓜网51官网版是您最值得信赖的娱乐八卦资讯平台。我们提供安全稳定的网页版与正式版访问入口，每日更新海量吃瓜资源，涵盖明星动态、影视爆料、综艺内幕等全方位娱乐资讯。吃瓜网51官方首页，让吃瓜变得更简单、更有趣。',
};